import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './permission' // permission control
import './plugins/element.js'
import './extend';

import './styles/index.scss' // global css
import Croppa from 'vue-croppa';
import 'vue-croppa/dist/vue-croppa.css';
import clipboard from 'clipboard';
// 引入 Sentry SDK 库
import * as Sentry from "@sentry/vue";

Vue.use(Croppa);
Vue.config.productionTip = false
Vue.prototype.clipboard = clipboard;

if (process.env.NODE_ENV === "production") {
  console.warn('env', process.env.NODE_ENV);
  Sentry.init({
    Vue,
    dsn: "https://183be1e356a882b8900d1938c92c2c30@ssentry.vs5rbqth.com/7",
  });
}

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
